import { render, staticRenderFns } from "./PolicyViewModal.vue?vue&type=template&id=7c458b64&"
import script from "./PolicyViewModal.vue?vue&type=script&lang=js&"
export * from "./PolicyViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports